import React from 'react';
import {content, iconLeft, leftBorder, leftBorderSelected, root, rootSelected} from "./styles";
import {ButtonProps} from "./types";

export const Button: React.FC<ButtonProps> = ({
    selected,
    text,
    icon,
    ...rest
}) => {
    return (
        <button css={[root, selected && rootSelected]} {...rest}>
            <div css={[leftBorder, selected && leftBorderSelected]} />
            <div css={content}>
                {icon && <span css={iconLeft}>{icon}</span>}
                <span>{text}</span>
            </div>
        </button>
    );
};